



























































import { computed, defineComponent } from "@vue/composition-api";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import FormatMoney from "@/components/FormatMoney";
import StatementItemDetailsTableItem from "./StatementItemDetailsTableItem.vue";
import { EarningReportData, EarningReportTypeStatDetails, StatField } from "../../types";
import StatementChartController from "../StatementChartController";

export default defineComponent({
  name: "StatementItemDetails",
  components: { FormatMoney, StatementItemDetailsTableItem, StatementChartController },
  props: {
    report: { type: Object as () => EarningReportData, required: true },
    fields: { type: Array as () => StatField[], required: true },
    totalDetails: { type: Object as () => EarningReportTypeStatDetails, required: true },
  },
  setup() {
    const { authUserStrict } = useAuthUser();
    const isTalentAgent = computed(() => checkRole(authUserStrict.value.role || "", "talent_agent"));
    return { isTalentAgent };
  },
});
